"use strict";
/*************************************************************************
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATIONS = exports.AGREEMENT_TYPE = void 0;
/**
 * The Agreements API allows an application to display an agreement modal which will block the user from using the feature until accepted.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import agreements from '@adobe/exc-app/agreements';
 * ```
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * To use a beta agreement dialog, all you need is the showAgreement function.
 * This function will show the dialog in the event that the user has not accepted yet, and get the users response:
 * ```typescript
 * import agreements from '@adobe/exc-app/agreements';
 *
 * const {accepted, date} = await agreements.showAgreement('my-beta-agreement-id', {type: AGREEMENT_TYPE.BETA});
 * ```
 *
 * If you need to get the response without showing the dialog, an additional get function is available:
 * ```typescript
 * import agreements from '@adobe/exc-app/agreements';
 *
 * const {accepted, date} = await agreements.getResponse('my-beta-agreement-id');
 *
 * ```
 * To clear the value in settings that the user has previously submitted:
 * ```typescript
 * import agreements from '@adobe/exc-app/agreements';
 *
 * const {accepted, date} = await agreements.clearResponse('my-beta-agreement-id');
 * ```
 *
 * API for fetching app data.
 * @packageDocumentation
 * @module agreements
 */
const Global_1 = require("./src/Global");
var AGREEMENT_TYPE;
(function (AGREEMENT_TYPE) {
    AGREEMENT_TYPE["AI"] = "AI";
    AGREEMENT_TYPE["BETA"] = "BETA";
})(AGREEMENT_TYPE = exports.AGREEMENT_TYPE || (exports.AGREEMENT_TYPE = {}));
var OPERATIONS;
(function (OPERATIONS) {
    OPERATIONS["CLEAR"] = "clear";
    OPERATIONS["GET"] = "get";
    OPERATIONS["SHOW"] = "show";
})(OPERATIONS = exports.OPERATIONS || (exports.OPERATIONS = {}));
const agreements = {
    clearResponse: (key, options) => (0, Global_1.getImpl)('agreements')().clearResponse(key, options),
    getResponse: (key, options) => (0, Global_1.getImpl)('agreements')().getResponse(key, options),
    showAgreement: (key, options) => (0, Global_1.getImpl)('agreements')().showAgreement(key, options)
};
exports.default = agreements;
//# sourceMappingURL=agreements.js.map